import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import SystemOfMeasuresQuery from './SystemOfMeasuresQuery';

const SystemOfMeasuresConnectorApollo = ({ children }) => {
  const { loading, error, data } = useQuery(SystemOfMeasuresQuery);

  const result = {
    loading,
    error,
  };

  if (!loading) {
    result.systemOfMeasures = data.me.systemOfMeasures;
    result.systemOfMeasuresNutrition = data.me.systemOfMeasuresNutrition;
  }

  return children(result);
};

SystemOfMeasuresConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default SystemOfMeasuresConnectorApollo;
